const Spacer = ({ height }) => (
    <div style={{ height: `${height}px` }} />
  );
  
  export default Spacer;
  